<script setup lang="ts">
const { $isAuthenticated, $logout } = useNuxtApp();

const me = ref<any>(null); // replace 'any' with your user type if available
onMounted(async () => {
  me.value = await $isAuthenticated(); // expect a user object or null
});
const nuxtApp = useNuxtApp();
nuxtApp.hook('directus:login', async () => {
  // when user logs in, update the state

  setTimeout(async () => {
    me.value = await $isAuthenticated();
    console.log('User logged in hook (delayed):', me.value);
  }, 1000);
  // me.value = await $isAuthenticated();
  // console.log('User logged in hook:', me.value);
});
async function doLogout() {
  await $logout(); // clear your auth/session
  me.value = null; // update reactive state so v-if re-renders
  await navigateTo('/'); // optional redirect
}
</script>

<template>
  <div v-if="me" class="flex flex-col relative bg-beigeFonce py-2 my-2 w-full sticky bottom-0 z-10">
    <div class="flex flex-row items-center justify-center gap-4">
      <div class="text-center"></div>
      {{ me.email }}
      <NuxtLink to="https://directus.helene-yoga-ecrins.fr/admin/visual" class="btn" target="_blank">
        Modifier le site
      </NuxtLink>
      <NuxtLink to="/admin/creneaux/sessions" class="btn">Inscriptions/admin</NuxtLink>
      <!-- logout button -->
      <div class="flex items-center justify-center">
        <button @click="doLogout()" class="btn btn-primary">Déconnection</button>
      </div>
    </div>
  </div>
</template>
